import { EmblaViewportRefType } from 'embla-carousel-react';
import { EmblaCarouselType } from 'embla-carousel';
import { CarouselOrientation, CarouselOverflow } from './Carousel.types';
import { createSafeContext } from '../../utils';
import { ResponsiveStyleValue } from '../../theming';

export interface CarouselContextValues {
    orientation: CarouselOrientation;
    overflow: CarouselOverflow;
    emblaRefElement: EmblaViewportRefType;
    emblaApi: EmblaCarouselType | undefined;
    slideSpacing: ResponsiveStyleValue<number>;
    visibleSlides: ResponsiveStyleValue<number | 'auto'>;
    handleKeydown: (event: React.KeyboardEvent<HTMLDivElement>) => void;
    title: string;

    // track user-initiated changes
    userInitiatedRef: React.MutableRefObject<boolean>;
    markUserInitiated: () => void;
}

export const [CarouselProvider, useCarouselContext] = createSafeContext<CarouselContextValues>(
    'Carousel component was not found in tree'
);
